<div fxLayout="row wrap">
    <div fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="100">
        <app-pace-calculator></app-pace-calculator>
    </div>
</div>
